import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import wow from "wowjs";
import "animate.css";
// import echarts from "echarts";
let echarts = require("echarts");
Vue.prototype._nsl$2 = 20;
import ElementUI from "element-ui";
import infiniteScroll from "vue-infinite-scroll";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/base.css";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import "./components/GlobalComponents.js";
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);
Vue.use(infiniteScroll);
Vue.prototype.$wow = wow;
Vue.component(CollapseTransition.name, CollapseTransition);
Vue.config.productionTip = false;
//获取 字符串 后缀名
String.prototype.getSuffix = function () {
  return this.substring(this.lastIndexOf(".") + 1);
};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
